import brandHomePage from "@areas/Brand/Views/Pages/BrandHomePage/xyl.views.brandHomePage.js";
import brandProductSearchPage from "@areas/Search/Views/Shared/DisplayTemplates/js/brand-product-search-page.js";
import commonSearchPage from "@areas/Search/Views/Shared/DisplayTemplates/js/common-search-page.js";
import salesdocuments from "@areas/Search/Views/Shared/DisplayTemplates/js/salesdocuments.module.js";
import productTabs from "@areas/CommerceCatalog/Views/Catalog/xyl.views.product-tabs.js";
import productPage from "@areas/CommerceCatalog/Views/Shared/Layouts/productPage.js";
import freeTextSearchTabs from "@areas/Search/Views/Shared/DisplayTemplates/js/freeTextSearchTabs.js";
import freeTextSearchPage from "@areas/Search/Views/Shared/DisplayTemplates/js/free-text-search-page.js";
import type { XylView } from "../../helpers/xyl-view-helpers";

export const pages: XylView[] = [
	brandHomePage,
	brandProductSearchPage,
	commonSearchPage,
	salesdocuments,
	productTabs,
	productPage,
	commonSearchPage,
	freeTextSearchTabs,
	freeTextSearchPage,
];
